export const ZIP_CODE_REGEX = /^\d+$/
export const CITY_REGEX = /^[A-Za-zÀ-ÖØ-öø-ÿ’'\-\s.]+$/